import React, { FC, ReactNode } from 'react';
import { InView } from 'react-intersection-observer';

import { usePageViewId } from '~/app/lib/use-page-view-id';
import { trackSegmentTrackEvent } from '~/app/lib/segment-analytics';

interface SegmentImpressionProps {
  children: ReactNode;
  className?: string;
  eventName: string;
  eventProps?: Record<string, any>;
  disabled?: boolean;
}

const SegmentImpression: FC<SegmentImpressionProps> = ({
  children,
  className,
  eventName,
  eventProps = {},
  disabled = false,
}) => {
  const pageViewId = usePageViewId();
  const handleViewChange = (inView: boolean) => {
    if (inView && !disabled) {
      trackSegmentTrackEvent(eventName, pageViewId, eventProps);
    }
  };

  return (
    <InView className={className} onChange={handleViewChange} triggerOnce>
      {children}
    </InView>
  );
};

export default SegmentImpression;
